import { motion } from "framer-motion";
import { DIFFERENTIATORS } from "../../data/site";

export const WhyUs = () => (
  <section
    id="why"
    data-testid="why-section"
    className="bg-[#F9F7F4] border-t border-[#E5DFD5] py-24 md:py-32"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-12 gap-6 mb-14 items-end">
        <div className="col-span-12 lg:col-span-7">
          <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
            Why ATC
          </div>
          <h2 className="font-display text-[#1C1B1A] text-4xl md:text-5xl lg:text-[4.5rem] leading-[1.02] tracking-tight">
            The neighbors
            <br />
            <span className="font-serif-accent italic text-[#C05746]">you'd recommend</span>.
          </h2>
        </div>
        <p className="col-span-12 lg:col-span-5 text-[#5C5A55] text-base md:text-lg leading-relaxed">
          We're not a franchise with a 1-800 number. We're a family business that
          has spent 35+ years earning one call, one handshake, one warranty at a time.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#E5DFD5]">
        {DIFFERENTIATORS.map((d, i) => (
          <motion.div
            key={d.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.06 }}
            className="relative border-r border-b border-[#E5DFD5] p-8 md:p-10 bg-[#F9F7F4] hover:bg-white transition-colors group"
            data-testid={`differentiator-${i}`}
          >
            <div className="font-mono text-[10px] text-[#5C5A55] mb-6">
              {String(i + 1).padStart(2, "0")} / {String(DIFFERENTIATORS.length).padStart(2, "0")}
            </div>
            <h3 className="font-display text-[#1C1B1A] text-2xl md:text-3xl tracking-tight leading-tight">
              {d.title}
            </h3>
            <p className="text-[#5C5A55] text-sm md:text-base leading-relaxed mt-4 max-w-sm">
              {d.desc}
            </p>
            <div className="absolute left-0 bottom-0 h-[2px] w-0 bg-[#C05746] group-hover:w-full transition-all duration-500" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
